import type { Subcategory } from '../model'
import { getSubcategory } from './get-subcategory'

export interface CategoryDeprecation {
  /** Display label of the deprecated category itself. */
  displayLabel: string
  /**
   * The category that replaces it, resolved from `supersededBy`.
   * `null` when the target is missing from the taxonomy.
   */
  supersededBy: Subcategory | null
}

/**
 * Returns deprecation details for a category, or `null` when it is active or unknown.
 *
 * Backend guarantees a `superseded_by` target on every deprecated entry, that the target
 * exists, and that the target is never itself deprecated — so this resolves in one hop.
 */
export function getCategoryDeprecation({
  category,
  subcategories,
}: {
  category: string | null | undefined
  subcategories: Subcategory[]
}): CategoryDeprecation | null {
  const subcategory = getSubcategory({ category, subcategories })

  if (!subcategory?.deprecated) {
    return null
  }

  return {
    displayLabel: subcategory.displayLabel,
    supersededBy: getSubcategory({ category: subcategory.supersededBy, subcategories }),
  }
}
